<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ $t('enterprises.title') }}</h1>
    <br>
    <!-- <v-toolbar color="primary" dark extended>
      <v-app-bar-nav-icon>
        <v-btn
          icon
          @click="handleAdd"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('enterprises.title') }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        @click="handleAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar> -->
    <custom-table
      icon="mdi-cellphone-android"
      title="enterprises.title"
      :headers="[{
          text: $t('enterprises.name'),
          align: 'left',
          sortable: false,
          value: 'ident',
        },
        { text: $t('enterprises.domain'), value: 'domain' },
        { text: 'Carta externa', value: 'externalPDF' },
        { text: '',
          align: 'left',
          sortable: false,
          value: 'actions' },
      ]"
      :data="data"
      :count="count"
      :loading="loading"
      :onAdd="handleAdd"
      :onSearch="handleChangeSearch"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import CustomTable from '@/components/CustomTable'
  export default {
    components: {
      CustomTable
    },
    data: () => ({
      page: 1,
      count: 0,
      itemPerPage: 10,
      searchValue: '',
      data: [],
      loading: false
    }),
    mounted () {
      this.handleGetEnterprises()
    },
    methods: {
      handleChangeSearch (searchValue, page) {
        this.searchValue = searchValue
        this.page = page
        this.handleGetEnterprises()
      },
      handleGetEnterprises () {
        this.loading = true
        api.getAll('enterprises', true, this.page, this.itemPerPage, this.searchValue).then(response => {
          this.count = response.count
          this.data = response.data.map(item => {
            return ({
              ident: {
                id: item.ID,
                name: item.Name
              },
              domain: item.Domain,
              externalPDF: `https://menu.dview.es/assets/menus/${item.ID}.pdf`,
              action: {
                id: item.ID
              }
            })
          })
          this.loading = false
        })
      },
      handleAdd () {
        this.$router.push('/enterprises/new')
      }
    }
  }
</script>
